import AllCandidatesLayout from '@/src/jobPortal/allCandidates/components/AllCandidatesLayout';

import JopPortalManagePermission from '../../common/containers/JopPortalManagePermission';

const AllCandidates = () => {
  return (
    <JopPortalManagePermission>
      <AllCandidatesLayout />
    </JopPortalManagePermission>
  );
};

export default AllCandidates;
